import { render } from "./Tabs.vue?vue&type=template&id=7111c5bd&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=7111c5bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7111c5bd"]])

export default __exports__